export function canAccessBackoffice(email: string) {
    return email.endsWith('@weezevent.com');
}
